import {HttpClient, RequestParams} from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import {IBeneficiaryGroupQuery} from "../../models/beneficiary-groups/query";
import {IBeneficiaryGroup, IBeneficiaryGroupDetails} from "../../models/beneficiary-groups/response";
import {ICreateBeneficiaryGroup, IUpdateBeneficiaryGroup} from "../../models/beneficiary-groups/request";

class BeneficiaryGroupsService<SecurityDataType = unknown> {
    http: HttpClient<SecurityDataType>;

    constructor(http: HttpClient<SecurityDataType>) {
        this.http = http;
    }

    getAllBeneficiaryGroups = (query: IBeneficiaryGroupQuery, params?: RequestParams) =>
        this.http.request<IBaseListingResponse<IBeneficiaryGroup>>({
            path: `/beneficiary-groups`,
            method: "GET",
            query,
            ...params,
        });

    getBeneficiaryGroup = (id: number, params?: RequestParams) =>
        this.http.request<IBeneficiaryGroupDetails>({
            path: `/beneficiary-groups/${id}`,
            method: "GET",
            ...params,
        });

    createBeneficiaryGroup = (data: ICreateBeneficiaryGroup, params?: RequestParams) =>
        this.http.request<IBeneficiaryGroup>({
            path: "/beneficiary-groups",
            method: "POST",
            body: data,
            ...params,
        });

    updateBeneficiaryGroup = (id: number, data: IUpdateBeneficiaryGroup, params?: RequestParams) =>
        this.http.request<IBeneficiaryGroup>({
            path: `/beneficiary-groups/${id}`,
            method: "PUT",
            body: data,
            ...params,
        });

    deleteBeneficiaryGroup = (id: number, params?: RequestParams) =>
        this.http.request<IBeneficiaryGroup>({
            path: `/beneficiary-groups/${id}`,
            method: "DELETE",
            ...params,
        });
}

export default BeneficiaryGroupsService;